@if (valid) {
  <mat-card class="mat-elevation-z3 no-content-padding">
    <mat-card-content>
      <dt-team-dashboard-utility-table [team]="team" [teamCalc]="teamCalc"></dt-team-dashboard-utility-table>
    </mat-card-content>
  </mat-card>
  <mat-card class="mat-elevation-z3">
    <mat-card-content>
      <dt-team-dashboard-utility-graph [team]="team" [teamCalc]="teamCalc"></dt-team-dashboard-utility-graph>
    </mat-card-content>
  </mat-card>
}

@if (!teamCalc && !errored) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

@if (teamCalc && !valid) {
  <h3 i18n>Diese Auswertung ist erst möglich, sobald das Projekt abgeschlossen ist.</h3>
}
@if (errored) {
  <h3 i18n>Es ist ein Fehler aufgetreten. Bitte versuche es später erneut.</h3>
}
